import React from 'react';
import { useLocation, useRouteMatch } from 'react-router';
import { Box, Divider, Tabs, Tab, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/CheckCircleOutlined';
import ScheduleIcon from '@material-ui/icons/AvTimerOutlined';
import LightbulbIcon from '@material-ui/icons/EmojiObjectsOutlined';
import { StyledText } from '../../../components/StyledText';
import { useConnectorDeals } from '../../../contexts';
import { ConnectorTab } from '../../../types/types';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
  },
  tabIndicator: {
    height: '3px'
  },
  divider: {
    padding: 0,
    margin: '-1px 0 0'
  },
  tabRoot: {
    display: 'flex',
    alignItems: 'center',
    '& > * + *': {
      marginLeft: '10px'
    }
  },
  tabAccent: {
    color: theme.palette.accent.main
  }
}));

interface CustomTabComponentProps {
  IconComponent: typeof DoneIcon;
  label: string;
  count: number;
  active: boolean;
}

const CustomTabComponent: React.FC<CustomTabComponentProps> = ({ IconComponent, label, count, active }) => {
  const styles = useStyles();
  return (
    <Box className={styles.tabRoot}>
      <IconComponent className={active ? styles.tabAccent : undefined} />
      <StyledText variant={active ? 'activeTab' : 'tab'}>{label}</StyledText>
      <StyledText className={styles.tabAccent} variant='counter'>{count}</StyledText>
    </Box>
  );
};

interface ConnectorTabsBarProps {
  onTabSelected: (value: string) => void;
}

export default function ConnectorTabsBar(props: ConnectorTabsBarProps) {
  const { newDealsTotalCount, inProgressDealsTotalCount, doneDealsTotalCount } = useConnectorDeals();
  const classes = useStyles();
  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const { onTabSelected } = props;

  const showTabs = [`${url}/${ConnectorTab.New}`, `${url}/${ConnectorTab.InProgress}`, `${url}/${ConnectorTab.Done}`].find((t) => t === pathname);

  const handleTabChange = async (event: React.ChangeEvent<{}>, value: string) => {
    onTabSelected(value);
  };
  return (
    <div className={classes.root}>
      {showTabs && (
        <Tabs
          value={pathname}
          onChange={handleTabChange}
          classes={{ indicator: classes.tabIndicator }}
          indicatorColor='primary'
          aria-label='connector deals tabs'
        >
          <Tab
            label={<CustomTabComponent IconComponent={LightbulbIcon} label='New' count={newDealsTotalCount} active={pathname.endsWith('new')} />}
            id='connector-new-deals-tab'
            value={`${url}/${ConnectorTab.New}`}
          />
          <Tab
            label={<CustomTabComponent IconComponent={ScheduleIcon} label='In Progress' count={inProgressDealsTotalCount} active={pathname.endsWith('inprogress')} />}
            id='connector-in-progress-deals-tab'
            value={`${url}/${ConnectorTab.InProgress}`}
          />
          <Tab
            label={<CustomTabComponent IconComponent={DoneIcon} label='Done' count={doneDealsTotalCount} active={pathname.endsWith('done')} />}
            id='connector-done-deals-tab'
            value={`${url}/${ConnectorTab.Done}`}
          />
        </Tabs>
      )}
      <Divider className={classes.divider} />
    </div>
  );
}
